import { render, staticRenderFns } from "./app-document-created.vue?vue&type=template&id=5eab8baf&"
import script from "./app-document-created.vue?vue&type=script&lang=js&"
export * from "./app-document-created.vue?vue&type=script&lang=js&"
import style0 from "./app-document-created.vue?vue&type=style&index=0&id=5eab8baf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports